import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { ConfigurationService, OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { Observable, switchMap } from 'rxjs';

interface MatchingRoute {
  matchingRoute: string | null;
  matchingConfig: OpenIdConfiguration | null;
}

function getClosestMatchingRoute(route: string, configurations: OpenIdConfiguration[]): MatchingRoute {
  for (const config of configurations) {
    const { secureRoutes } = config;

    for (const configuredRoute of secureRoutes ?? []) {
      if (route.startsWith(configuredRoute)) {
        return { matchingRoute: configuredRoute, matchingConfig: config };
      }
    }
  }

  return { matchingRoute: null, matchingConfig: null };
}

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const configurationService: ConfigurationService = inject(ConfigurationService);
  const auth: OidcSecurityService = inject(OidcSecurityService);

  const allConfigurations: OpenIdConfiguration[] = configurationService.getAllConfigurations();
  const allRoutesConfigured: string[] = allConfigurations.map(config => config.secureRoutes ?? []).flat();

  const { matchingConfig } = getClosestMatchingRoute(req.url, allConfigurations);

  return auth.getIdToken().pipe(
    switchMap((token: string) => {
      if (!matchingConfig || !token || allRoutesConfigured.length === 0) {
        return next(req);
      }

      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
    }),
  );
};
